export function isHex(value,{strict:strict=!0}={}){return!!value&&("string"==typeof value&&(strict?/^0x[0-9a-fA-F]*$/.test(value):value.startsWith("0x")))}